import { render, staticRenderFns } from "./FireResistanceOuter.vue?vue&type=template&id=a5dadd12&"
import script from "./FireResistanceOuter.vue?vue&type=script&lang=js&"
export * from "./FireResistanceOuter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports